import { Icon, LinkButton } from '@/components/ui';
import { paths } from '@/routes/paths';

/**
 * Stands in for posting an internship or growing the team until the company is
 * verified. Pair with `useCompanyVerification`; the workspace banner carries
 * the explanation, so this is only the way forward.
 */
export function VerifyToContinueButton({ size, variant = 'primary', className }) {
  return (
    <LinkButton to={paths.company.verification} size={size} variant={variant} className={className}>
      <Icon name="shieldCheck" size={16} />
      Verify to continue
    </LinkButton>
  );
}
